/**
 * Created by Languagenut on 22/10/2019.
 */


/**
 * Created by mark on 29/01/2018.
 */

import React  from 'react';
import {ProgressBar , Button , Breadcrumb , FormGroup , ControlLabel , Tabs , Tab , Row , Col , NavItem , Nav} from 'react-bootstrap';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

import ReportServices from '../../../services/reports-service.js';
import BaseDetailed from './DetailViewBase.js';
import Base from  './vocabulary.js';


export default class SentenceCourseTable extends Base {

    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(props){
        this.props = props
        this.setState({update:true})
    }

    componentDidMount(){

        ReportServices.getSentenceBuildingDetailed(this.props.module.sentence_catalog  , this.props.classID , this.props.set , this.props.due , this.props.language , this.props.module.sentence_catalog , this.props.studentID).then(function(response){

            this.setState({
                module:module,
                detailedHeaders:response.headers,
                detailedData:response.data,
                title:this.props.module.title
            });

        }.bind(this));
    }

    render(){
        if(!this.state.detailedHeaders) return null;

        return  <BaseDetailed module={this.state.module} triggerDownload={this.props.triggerDownload} studentID={this.props.studentID} onClick={() =>{this.setState({detail:false})}} name={this.state.title} headers={this.state.detailedHeaders || []} data={this.state.detailedData || []}/>

    }


}